// Stores navigation direction on link click so the next page can animate the calendar.
// Works with Turbo Drive: direction is stored before navigation, read on connect.
import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "calendarNavDirection"

export default class extends Controller {
  static targets = ["content"]
  static values = { direction: String }

  // Call from nav links via mousedown (fires before navigation)
  storeDirection() {
    if (this.directionValue) {
      sessionStorage.setItem(STORAGE_KEY, this.directionValue)
    }
  }
}
